export const CUSTOM_FILTER_CHECKBOX_PALETTE = 'checkboxPalette';
export const CUSTOM_FILTER_DATEPICKER = 'datepicker';
export const CUSTOM_FILTER_DROPDOWN_SELECT = 'dropdownSelect';
export const CUSTOM_FILTER_TEXT = 'text';
export const CUSTOM_FILTER_TYPEAHEAD = 'typeahead';
